<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...$$props}>
  <g fill="currentColor" fill-rule="evenodd" clip-path="url(#a)" clip-rule="evenodd">
    <path
      d="M6.34 10.58a4.374 4.374 0 0 0 5.193-3.374c.509-2.376-1-4.707-3.354-5.215a4.374 4.374 0 0 0-5.193 3.373c-.509 2.377 1 4.708 3.354 5.215m-.364 1.703c3.3.71 6.55-1.397 7.26-4.71C13.944 4.261 11.844 1 8.543.288s-6.55 1.397-7.26 4.71c-.708 3.311 1.393 6.573 4.693 7.285"
    />
    <path d="m12.304 15.821-2.965-4.7 1.473-.929 2.964 4.701z" />
  </g>
  <defs>
    <clipPath id="a">
      <path fill="currentColor" d="M0 0h16v16H0z" />
    </clipPath>
  </defs>
</svg>
